<template>
    <form-input-layout :active="active" :help-item-code="helpItemCode">
        <template slot="caption">
            {{caption}}<strong v-if="required" class="required">*</strong>
        </template>
        <template slot="input">
            <div class="input-content">
                <input :class="{ 'input-component': true, 'active': active}" @focus="toggleActive" @blur="toggleActive"  v-model="internalValue" type="color" :disabled="disabled"/>
                <div>[{{internalValue == null ? "No color" : internalValue}}]</div>
                <small-icon-button icon="times" @press="makeNull"/>
            </div>
        </template>
    </form-input-layout>
</template>

<script>
    import FormInputLayout from "./FormInputLayout";
    import FormInputMixin from "./FormInputMixin";
    import SmallIconButton from "../button/SmallIconButton";
    export default {
        name: "FormColorInput",
        components: {SmallIconButton, FormInputLayout},
        mixins: [FormInputMixin],
        props: {
            helpItemCode: String
        },
        methods: {
            makeNull() {
                this.internalValue = null;
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/global";

.input-component {
    background-color: transparent;
    border: none;
    border: 1px solid var(--input-border-color);
    background-color: var(--input-background-color);
    border-radius: 5px;
    color: var(--input-font-color);
    padding: 0 0;
    outline: none;
    width: 40px;
    font-family: Source Sans Pro;
}

    .active {
        color: var(--input-active-font-color);
        background-color: var(--input-active-background-color);
        border: 1px solid var(--input-active-border-color);
    }

    .required {
        color: var(--accent-color);
    }

    .input-content {
        &>* {
            margin-right: 10px;
        }
        display: flex;
        flex-flow: row;
        align-items: center;
    }
</style>